import { render } from "./Editor.vue?vue&type=template&id=7a05aa84&ts=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__